export default function Marquee({ items, className = '' }) {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden border-y border-zinc-900 py-5 ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap font-heading text-2xl font-bold uppercase tracking-wide text-zinc-700">
            {item}
            <span className="brand-text text-sm">●</span>
          </span>
        ))}
      </div>
    </div>
  );
}
